var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3889 11.3601L7.8911 3.11114C7.77741 3.04166 7.64726 3.00372 7.51404 3.00123C7.38083 2.99874 7.24935 3.03177 7.13314 3.09695C7.01692 3.16212 6.92017 3.25708 6.85283 3.37205C6.7855 3.48702 6.75 3.61786 6.75 3.7511V20.249C6.75 20.3822 6.7855 20.513 6.85283 20.628C6.92017 20.743 7.01692 20.8379 7.13314 20.9031C7.24935 20.9683 7.38083 21.0013 7.51404 20.9988C7.64726 20.9963 7.77741 20.9584 7.8911 20.8889L21.3889 12.64C21.4985 12.573 21.5891 12.479 21.652 12.3669C21.7148 12.2548 21.7478 12.1285 21.7478 12C21.7478 11.8716 21.7148 11.7452 21.652 11.6332C21.5891 11.5211 21.4985 11.4271 21.3889 11.3601Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.f322ddceb2190b244725ca503b94cabb.svg";
export { ForwardRef as ReactComponent };